import { render } from "./AdminDataTable.vue?vue&type=template&id=885d4ba0&scoped=true"
import script from "./AdminDataTable.vue?vue&type=script&lang=js"
export * from "./AdminDataTable.vue?vue&type=script&lang=js"

import "./AdminDataTable.vue?vue&type=style&index=0&id=885d4ba0&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-885d4ba0"]])

export default __exports__